// extracted by mini-css-extract-plugin
module.exports = {"title":"_3ICBm2Og","searchTitle":"_3CYPWcHs","editorWrapper":"_3BWQ5fxv","advancedTextEditor":"Pv3AJKbD","containerTooLongText":"_2iNMx9dV","textTooLongText":"_20Nbhsnl"};